import { get } from 'lodash';

import * as actions from '../actions/movie-actions';

const initialState = {};

// reducer
export default function movies(state = initialState, action = {}) {
  switch (action.type) {
    case actions.MOVIE_SUCCESS:
      return Object.assign({}, state, {
        [action.fetchedMovie.uuid]: action.fetchedMovie
      });

    default:
      return state;
  }
}

// selectors
export const selectMovies = state => get(state, 'movies', {});
export const getMovie = (movieId, state) =>
  get(state, `movies.${movieId}`, null);
export const getFiltersForMovie = (movieId, state) => ({
  ...state.filters,
  fields: {
    ...state.filters.fields,
    movie: {
      id: 'movie',
      label: 'Movie',
      value: { label: '', value: movieId }
    }
  }
});
